<template>
  <b-tabs
    vertical
    content-class="col-12 col-md-9 mt-1 mt-md-0"
    pills
    nav-wrapper-class="col-md-3 col-12"
    nav-class="nav-left"
  >
    <!-- datos de facturacion -->
    <!-- <b-tab active>
      <template #title>
        <feather-icon
          icon="ToolIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Datos Facturación</span>
      </template>
      <datos-facturacion
        class="pb-1"
        :external-user="{}"
      />
    </b-tab> -->

    <!-- Documentación -->
    <!-- <b-tab active>
      <template #title>
        <feather-icon
          icon="BookIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Documentación</span>
      </template>
      <documentacion :inmatricula="inmtrl" />
    </b-tab> -->

    <!-- Cambio de contraseña -->
    <b-tab active>
      <template #title>
        <feather-icon
          icon="LockIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Cambio de contraseña</span>
      </template>
      <account-setting-password />
    </b-tab>

    <!-- Notificaciones -->
    <b-tab>
      <template #title>
        <feather-icon
          icon="BellIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Notificaciones</span>
      </template>
      <account-setting-notification />
    </b-tab>
    <!-- Habilitar Auth2 -->
    <!-- <b-tab
      lazy
    >
      <template #title>
        <feather-icon
          icon="ShieldIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Seguridad</span>
      </template>
      <seguridad />
    </b-tab> -->
  </b-tabs>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'
// import DatosFacturacion from '@/views/components/informacion-factura/ConfigDF.vue'
import store from '@/store'
import { ref } from '@vue/composition-api'
// import documentacion from './Documentacion.vue'
import AccountSettingPassword from './AccountSettingPassword.vue'
import AccountSettingNotification from './AccountSettingNotification.vue'
// import Seguridad from './Seguridad.vue'

export default {
  components: {
    BTabs,
    BTab,
    // DatosFacturacion,
    // documentacion,
    AccountSettingPassword,
    AccountSettingNotification,
    // Seguridad,
  },
  setup() {
    const inmtrl = ref(0)
    inmtrl.value = (store && store.state && store.state.cuenta && store.state.cuenta.info && store.state.cuenta.info.matricula) ? store.state.cuenta.info.matricula : 0
    return {
      inmtrl,
    }
  },
}
</script>
